// extracted by mini-css-extract-plugin
export default {"nav_bloc":"ItemDropdown_nav_bloc__mnb4l","content_container":"ItemDropdown_content_container__2SFL7","name":"ItemDropdown_name__qHknx"};